import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { DatosGeneralesEmpresaService } from "./datos-generales-empresa.service";
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { DatosPorSegmentoEntity } from "../entities/datos_por_segmento_entity";
import { ContactosTecniEntity } from "../entities/contactos_tecni_entity";
import { ContactosClienteEmpresaEntity } from "../entities/contactos_cliente_empresa_entity";
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { CalendarFechaNacParametros } from "../../../components/common/utils/calendarFechaNacParametros";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { UtilService } from "../../../components/common/utils/util.service";

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'datosGeneralesEmpresa',
    providers: [DatosGeneralesEmpresaService],
    templateUrl: 'datos-generales-empresas.template.html',
    styleUrls: ["datos-generales-empresa.style.css"]

})

export class DatosGeneralesEmpresa extends CalendarFechaNacParametros implements OnInit {
    showLoader: string;
    userEmpresa: ClienteXCiudad;
    usuario: ClienteLogin;
    datosGeneralesEmpresa: DatosGeneralesEntity;
    datosPorUsuario: ContactosClienteEmpresaEntity;
    contactosTecni: ContactosTecniEntity[];
    contactosCliente: ContactosClienteEmpresaEntity[];
    listaActividadEco: ListaDiccionaryEntity[];
    tipoUsuario: number;
    segmentoModificado: DatosPorSegmentoEntity;
    @ViewChild('modificarDireccionSegmento')
    modal: ModalComponent;

    constructor(private datosGeneralesEmpresaService: DatosGeneralesEmpresaService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public utilsService: UtilService
    ) {
        super();
    }
    ngOnInit(): void {
        try {
            /*correctHeight();
            detectBody();*/
            this.segmentoModificado = new DatosPorSegmentoEntity();
            this.showLoader = "sk-loading";
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            this.CargarDatos();

            this.sesionStorageService.observe("usuario").subscribe(a => {
                try {
                    this.usuario = jQuery.parseJSON(a);
                    this.CargarDatos();
                } catch (ex) {
                    this.usuario = a;
                    this.CargarDatos();
                }
            })
        } catch (ex) {

        }
    }

    CargarDatos() {
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.tipoUsuario= this.usuario.TipoCliente;
                this.datosGeneralesEmpresa = new DatosGeneralesEntity();
                this.datosPorUsuario = new ContactosClienteEmpresaEntity();
                this.contactosTecni = new Array<ContactosTecniEntity>();
                this.contactosCliente = new Array<ContactosClienteEmpresaEntity>();
                let c = new ContactosTecniEntity();
                try {
                    this.userEmpresa = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioEmpresa"));
                } catch (e) {
                    this.userEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                }
                this.datosGeneralesEmpresaService.datosGeneralesEmpresa(this.userEmpresa).subscribe(
                    datosGeneralesEmpresa => {
                        this.datosGeneralesEmpresa = datosGeneralesEmpresa;    
                        this.datosGeneralesEmpresa.DatosPorSegmentoModificados = new Array<DatosPorSegmentoEntity>();                    
                        this.showLoader = "";
                    },
                    error => { this.handleError.redirectUrl(error); });

                let cedula = this.usuario.Cedula;
                this.userEmpresa.Cedula = cedula;


                this.datosGeneralesEmpresaService.consultarDatosUsuario(this.userEmpresa).subscribe(
                    datosPorUsuario => {
                        this.datosPorUsuario = datosPorUsuario;
                    },
                    error => { this.handleError.redirectUrl(error); });

                this.datosGeneralesEmpresaService.consultaActividadEconomica().subscribe(
                    listadoActividad => {
                        this.listaActividadEco = listadoActividad;
                    },
                    error => { this.handleError.redirectUrl(error); });
            }
        }
    }

    CargarDatosPorUsuario() {
        try {
            this.datosGeneralesEmpresaService.consultarDatosUsuario(this.userEmpresa).subscribe(
                datosPorUsuario => {
                    this.datosPorUsuario = datosPorUsuario;

                },
                error => { this.handleError.redirectUrl(error); });

        }
        catch (e) {
        }
    }
    actualizarDatosContacto(): void {
        this.datosPorUsuario.CodigoUsuario = this.usuario.CodigoUsuario;
        this.datosGeneralesEmpresaService.actualizarDatosUsuario(this.datosPorUsuario).subscribe(
            datosContacto => {
                if (datosContacto) {
                    swal({
                        title: 'Datos actualizados',
                        text: "Su información ha sido actualizada satisfactoriamente",
                        type: 'success'
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); });
    }

    actualizarDatosEmpresa(): void {
        this.datosGeneralesEmpresa.CodigoUsuario = this.usuario.CodigoUsuario;
        this.datosGeneralesEmpresaService.actualizarDatosGeneralesEmpresa(this.datosGeneralesEmpresa).subscribe(
            datosContacto => {
                if (datosContacto) {
                    swal({
                        title: 'Datos actualizados',
                        text: "Su información ha sido actualizada satisfactoriamente",
                        type: 'success'
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); });
    }

    editarInformacionXSegmento(segmento: DatosPorSegmentoEntity){
        this.segmentoModificado = new DatosPorSegmentoEntity();
        this.segmentoModificado = this.cloneSegmento(segmento);
        this.modal.open();
    }

    modificarSegmento(){
        this.datosGeneralesEmpresa.DatosPorSegmento.forEach(a=>{
            if(a.UniCod == this.segmentoModificado.UniCod){
                a.Telefono2 = this.segmentoModificado.Telefono2;
                a.Telefono1 = this.segmentoModificado.Telefono1;
                a.Direccion = this.segmentoModificado.Direccion;
            }
        });
        this.segmentoModificado = new DatosPorSegmentoEntity();
        this.modal.close();
    }

    modalClose(){
        this.modal.close();
        this.segmentoModificado = new DatosPorSegmentoEntity();
    }

    cloneSegmento(c: DatosPorSegmentoEntity) {
        let segmento = new DatosPorSegmentoEntity();
        for (let prop in c) {
            segmento[prop] = c[prop];
        }
        return segmento;
    }

    set dateS(e) {
        this.datosPorUsuario.FechaNacimiento = new Date(e);
    }

    get dateS() {
        if (this.datosPorUsuario.FechaNacimiento != undefined) {
            try {
                var a = this.datosPorUsuario.FechaNacimiento.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.datosPorUsuario.FechaNacimiento.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/datosGenerales/datos-generales-empresa.component.ts